export default "__VITE_ASSET__BXdtNFfl__"